import { FinancialReceivementCard } from "@gipi-financial/receivement-card-administrator/models/receivement-card.model";
import { GIPIAbstractDTO, GIPIUuid } from "@gipisistemas/ng-core";

export class FinancialReceivementCardCreditClientDTO extends GIPIAbstractDTO {

    /** @Required Valor */
    amountCard: number;

    /** @Required Valor líquido */
    amountNet: number;

    /** @Required Id da administradora de cartão */
    cardAdministratorId: GIPIUuid;

    /** @Required Data de vencimento */
    dueDate: Date;

    /** @Required Id da bandeira do cartão */
    flagCardId: GIPIUuid;

    /** @Required Data de emissão */
    issuanceDate: Date;

    /** @Required */
    numberInstallment: number;

    constructor(id?: GIPIUuid) {
        super();
        this.id = id;
    }

    public static transformToDTO(receivementCard: FinancialReceivementCard): FinancialReceivementCardCreditClientDTO {
        const dto = new FinancialReceivementCardCreditClientDTO();
        dto.id = receivementCard.id;
        dto.enabled = receivementCard.enabled;
        dto.amountCard = receivementCard.amountCard;
        dto.amountNet = receivementCard.amountNet;
        dto.cardAdministratorId = receivementCard.cardAdministrator.id;
        dto.dueDate = receivementCard.dueDate;
        dto.flagCardId = receivementCard.flagCard.id;
        dto.issuanceDate = receivementCard.issuanceDate;
        dto.numberInstallment = receivementCard.numberInstallment;
        return dto;
    }

}
